/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type KioskContainer_viewer$ref: FragmentReference;
export type KioskContainer_viewer = {|
  +id: string,
  +embed_token: ?string,
  +s_recaptcha_enabled: ?boolean,
  +s_recaptcha_site_key: ?string,
  +s_recaptcha_secret_key: ?string,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: KioskContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "KioskContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "embed_token",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_enabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_site_key",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_secret_key",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'efc2835779931a9a71da26c13a93ad42';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Leads/__generated__/KioskContainer_viewer.graphql.js